import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { router } from './routes';
import { initializeAuth } from './features/auth/stores/authStore';
import { ConnectionBanner } from './shared/components/ConnectionBanner';
import { TOKEN_REFRESHED_EVENT } from './lib/resilientFetch';

function App() {
  // Initialize auth from localStorage on app start
  useEffect(() => {
    initializeAuth();
  }, []);

  // Cross-tab auth synchronization
  // When user logs in/out in another tab, this tab will sync
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      // Sync auth state when relevant keys change
      if (
        e.key === 'nexedu-auth-storage' ||
        e.key === 'nexedu_access_token' ||
        e.key === 'nexedu_user'
      ) {
        // Re-initialize auth from localStorage
        initializeAuth();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // After a silent token refresh (same tab) the Zustand copy of the tokens
  // must follow localStorage, or screens reading tokens from the store keep
  // sending the expired JWT until the next full reload.
  useEffect(() => {
    const handleRefreshed = (): void => initializeAuth();
    window.addEventListener(TOKEN_REFRESHED_EVENT, handleRefreshed);
    return () => window.removeEventListener(TOKEN_REFRESHED_EVENT, handleRefreshed);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <ConnectionBanner />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: {
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
          },
          success: {
            style: {
              background: '#ecfdf5',
              color: '#065f46',
              border: '1px solid #a7f3d0',
            },
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            style: {
              background: '#fef2f2',
              color: '#991b1b',
              border: '1px solid #fecaca',
            },
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  );
}

export default App;
